import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

class SideBar extends React.Component {

   

    render() {


        const { loggedIn, location} = this.props;


        return (
            <div className="sidebar-menu">
                <img src="/images/wgc-logo.png" className="logo" alt="logo"/>
                <div className="navigation-holder">
                    <Link to="/">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/clubhouse.svg" alt="Dashboard"/>
				            </div>
                                Dashboard
			             </div>
                    </Link>

                    <Link to="/management">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/leaderboard.svg" alt="Management" />
		                    </div>
                                Management
	                        </div>
                    </Link>
                
                    {loggedIn ?
                        <Link to="/payments">
                            <div className="menu-item">
                                <div className="img-holder">
                                    <img src="/images/icons/wallet.svg" alt="Payments"/>
                                </div>
                                Payments
			                </div>
                        </Link>
                        : null
                    }
                    {loggedIn ?
                        <Link to="/withdrawals">
                            <div className="menu-item">
                                <div className="img-holder">
                                    <img src="/images/icons/settings.svg" alt="Withdrawals"/>
                            </div>
                                Widthrawal requests
			                </div>
                        </Link>
                        : null
                    }
                    <Link to="/users">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/faq.svg" alt="Users"/>
				            </div>
				                Users
			            </div>
                    </Link>
                    {loggedIn ?
                        <Link to="/discounts">
                            <div className="menu-item">
                                <div className="img-holder">
                                    <img src="/images/icons/settings.svg" alt="Discounts" />
                                </div>
                                Discount codes
			                </div>
                        </Link>
                        : null
                    }
                    <Link to="/availablechallenges">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/faq.svg" alt="Available Challenges" />
                            </div>
				                Available Challenges
			            </div>
                    </Link>
                    <Link to="/challenges">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/faq.svg" alt="Challenges" />
                            </div>
				            Running/Finished
			            </div>
                    </Link>
                    {loggedIn ?
                        <Link to="/logs">
                            <div className="menu-item">
                                <div className="img-holder">
                                    <img src="/images/icons/settings.svg" alt="Logs" />
                                </div>
                                Logs
			                </div>
                        </Link>
                        : null
                    }

                    {loggedIn ?
                    <Link to="/logout">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/logout.svg" alt="Logout"/>
				            </div>
				            Sign out
			            </div>
                        </Link>
                        : null
                    }

	            </div>
               
                
           </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        loggedIn: state.userReducer.loggedIn,
    };
}

const sideBar = withRouter(connect(mapStateToProps)(SideBar));
export { sideBar as SideBar }; 